"use strict";

exports.__esModule = true;
exports.default = categorify;

function categorify(data) {
  const categories = [];
  data.forEach(({
    id,
    name,
    slug
  }) => {
    categories[id] = {
      name,
      slug
    };
  });
  return categories;
}